import type { IGenericBaseModel } from "models/shared/GenericBaseModel";
import { FlowModel, type IFlowModel } from "models/flow/FlowModel";
import React from "react";

/**
 * Interface para o modelo de funcionalidades de um Locker.
 * Cada funcionalidade é representada por um fluxo de navegação.
 */
export interface ILockerFeaturesModel extends IGenericBaseModel {
  preRegisteredAllocateFlow?: string;
  allocateFlow?: string;
  deallocateFlow?: string;
  reverseFlow?: string;
  correiosAllocateFlow?: string;
  returnFlow?: string;
  returnDeallocateFlow?: string;
}

/**
 * Classe que representa as funcionalidades (fluxos) disponíveis em um Locker.
 */
export class LockerFeaturesModel implements ILockerFeaturesModel {
  uuid?: string;
  key?: React.Key;
  preRegisteredAllocateFlow?: string;
  allocateFlow?: string;
  deallocateFlow?: string;
  reverseFlow?: string;
  correiosAllocateFlow?: string;
  returnFlow?: string;
  returnDeallocateFlow?: string;

  constructor(data: ILockerFeaturesModel) {
    this.uuid = data?.uuid;
    this.key = data?.uuid;

    this.preRegisteredAllocateFlow = data.preRegisteredAllocateFlow;
    this.allocateFlow = data.allocateFlow;
    this.deallocateFlow = data.deallocateFlow;
    this.reverseFlow = data.reverseFlow;
    this.correiosAllocateFlow = data.correiosAllocateFlow;
    this.returnFlow = data.returnFlow;
    this.returnDeallocateFlow = data.returnDeallocateFlow;
  }
}